/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/1
 * @updateTime 2021/9/1
 * @decription 申请复议-申请人相关处理js
 * @namespace 【sqr】
 */
// 新增申请人表单
import addSQR from '../addReconsider/addSQR/index.vue';
import {Dialog} from "vant";
import {typeRylx} from "@/filters";
export default {
    // 依赖组件
    components: {addSQR},
    // 数据
    data() {
        return {
            // 申请人数据列表
            sqrDataList: [],
            // 是否显示弹层
            showPopupSqr: false,
            // 正在编辑的申请人信息项
            sqrEditItem: null,
            // 正在编辑的申请人信息项索引
            sqrEditIndex: -1,
            // 申请人删除的id集合
            sqrDelIds: [],
            // 申请人加载完成
            sqrLoaded: false
        };
    },
    // 方法
    methods: {

        /**
         * 获取申请人数据
         * @returns {void}
         * */
        sqrGetData() {
            // 请求复议申请人接口
            this.requestFySqr({
                // 复议id
                fyid: this.fyid,
                // 保全id
                bqid: this.bqid
            }).then((res) => {
                const _sqrDataList = [];
                // 循环遍历数据处理数据
                res.data.forEach(item => {
                    // 如果保全id存在，则说明是从我的保全申请列表中跳转过来，这个是带过来的申请人列表，需要手动附上fyid
                    if (this.bqid) {
                        // 复议id
                        item.cFyId = this.fyid;
                    }
                   // 申请人类型文本
                   item.cSqrlxText = typeRylx(item.cSqrlx);
                    _sqrDataList.push(item);
                });
                // 赋值申请人数据列表
                this.sqrDataList = _sqrDataList;
                // 申请人加载完成
                this.sqrLoaded = true;
                // 上传材料同步申请人数据
                this.bqid && this.scclSyncSqrData();
            });
        },

        /**
         * 添加、编辑申请人
         * @param {Object} item 申请人信息项数据
         * @param {Number} index 索引
         * @returns {void}
         * */
        sqrAddAEdit(item, index){
            if (item) {
                this.sqrEditItem = item;
                this.sqrEditIndex = index;
            }
            // 生成申请人表单
            this.showPopupSqr = true;
        },

        /**
         * 删除申请人
         * @param {String} sqrid 申请人id
         * @param {Number} index 当前申请人索引
         * @returns {void}
         * */
        sqrDelete(sqrid, index) {
            Dialog.confirm({
                title: '提示',
                message: '删除申请人后，对应的代理人和身份证明材料可能会一并删除，确认删除吗？',
                confirmButtonColor: '#ffffff',
                cancelButtonColor: '#ffffff'
            }).then(() => {
                // 删除对应的复议申请人
                this.sqrDataList.splice(index, 1);
                // 删除的id集合中存储对应的申请人id
                this.sqrDelIds.push(sqrid);
                // 根据申请人id删除对应的代理人列表
                this.dlrDeleteBySqrId(sqrid);
                // 根据人员id进行对应的身份证明材料的删除
                this.scclDelByRyId(sqrid);
            }).catch(() => {

            });
        },

        /**
         * 取消添加、编辑申请人
         * @returns {void}
         * */
        sqrCancel() {
            // 编辑信息项置为null
            this.sqrEditItem = null;
            // 索引置为-1
            this.sqrEditIndex = -1;
            // 申请人弹层为false
            this.showPopupSqr = false;
        },

        /**
         * 获取转化申请人数据
         * @param {Object} formData 表单数据
         * @returns {Object} 转化之后的数据
         * */
        sqrGetTransformData(formData) {
            const _transformData = {
                ...formData
            };
            return _transformData;
        },

        /**
         * 处理申请人确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        sqrHandlerConfirm(formData) {
            const _transformData = this.sqrGetTransformData(formData);
            // 如果编辑数据，则说明是编辑数据
            if (this.sqrEditItem && this.sqrEditIndex > -1) {
                // 进行数据替换
                this.sqrDataList.splice(this.sqrEditIndex, 1, _transformData);
            } else {
                // 添加数据
                this.sqrDataList.push(_transformData);
            }

            // 同步人员名称
            this.scclSyncDataByRyId(_transformData.cId, this.sqrGetName(_transformData) + '-' + _transformData.cSqrlxText, true);
        },

        /**
         * 获取申请人名称
         * @param {Object} itemData 申请人信息项数据
         * @returns {String} 申请人名称
         * */
        sqrGetName(itemData) {
            // 如果是自然人，则取申请人名称，否则取企业名称
            return itemData.cSqrlx == '1' ? itemData.cSqrxm : itemData.cQymc;
        },

        /**
         * 添加、编辑申请人表单确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        sqrConfirm(formData) {
            // 确认处理操作
            this.sqrHandlerConfirm(formData);
            // 申请人取消为false
            this.sqrCancel();
        },

        /**
         * 添加并继续
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        sqrConfirmAContinue(formData) {
            // 确认处理操作
            this.sqrHandlerConfirm(formData);
        }
    }
};
